import { MapMarkerType, PropertySaleType, QuickFilter } from '../types';
import SelectedMarker from '../components/markers/icons/SelectedMarker';
import DefaultMarker from '../components/markers/icons/DefaultMarker';
import FirstDestinationMarker from '../components/markers/icons/FirstDestinationMarker';
import SecondDestinationMarker from '../components/markers/icons/SecondDestinationMarker';
import FinanceIcon from '../../../new-components/svg-icons/FinanceIcon';
import DeliveryDateIcon from '../../../new-components/svg-icons/DeliveryDateIcon';
import PropertyTypeIcon from '../../../new-components/svg-icons/PropertyTypeIcon';
import { SearchFiltersTypes } from '../../../reducers/search-filters/reducer';
import UnfilteredMarker from '../components/markers/icons/UnfilteredMarker';
import NawyNowMapFilterIcon from '../../../new-components/svg-icons/NawyNowMapFilterIcon';

export const MarkersMap = new Map([
  [MapMarkerType.SELECTED, SelectedMarker],
  [MapMarkerType.DEFAULT, DefaultMarker],
  [MapMarkerType.FIRST_DESTINATION, FirstDestinationMarker],
  [MapMarkerType.SECOND_DESTINATION, SecondDestinationMarker],
  [MapMarkerType.UNFILTERED, UnfilteredMarker]
]);

export const quickFilters = [
  {
    type: QuickFilter.NAWY_NOW,
    label: 'Nawy Now',
    icon: NawyNowMapFilterIcon
  },
  { type: QuickFilter.PRICE, label: 'price_range', icon: FinanceIcon },
  { type: QuickFilter.DELIVERY, label: 'delivery', icon: DeliveryDateIcon },

  {
    type: QuickFilter.PROPERTY_TYPE,
    label: 'property_types',
    icon: PropertyTypeIcon
  }
];

export const unit_area_list = [
  { value: 50, options: { displayedValue: '50' } },
  { value: 80, options: { displayedValue: '80' } },
  { value: 100, options: { displayedValue: '100' } },
  { value: 150, options: { displayedValue: '150' } },
  { value: 200, options: { displayedValue: '200' } },
  { value: 250, options: { displayedValue: '250' } },
  { value: 300, options: { displayedValue: '300' } },
  { value: 350, options: { displayedValue: '350' } },
  { value: 400, options: { displayedValue: '400' } }
];

export const amenities = [
  {
    filterType: SearchFiltersTypes.AMENITIES,
    value: 1,
    options: { displayedValue: 'garden' }
  },
  {
    filterType: SearchFiltersTypes.AMENITIES,
    value: 2,
    options: { displayedValue: 'roof' }
  }
];

export const saleTypes = [
  PropertySaleType.All,
  PropertySaleType.Developer_Sale,
  PropertySaleType.Resale,
  PropertySaleType.NAWY_NOW
];
